import { defineComponent as _defineComponent } from 'vue'
import type { TitleDetail } from '@/interfaces/title-details-graphql';

import { ObjectType } from '@/@types/graphql-types';
import { useI18n } from '@/helpers/composables/useI18n';
import { OfferLocation } from '@/helpers/offer-helper';
import { SnowplowContext } from '@/helpers/tracking/providers';
// need to import this immediately because it's above the fold and could cause CLS
import ListOffer from '@/features/buybox/components/list/ListOffer.vue';

import { useProvideClickoutPlacement } from '@/helpers/composables/useProvideClickoutPlacement';

import { BuyboxRegularOffer } from '@/features/buybox/types/types';
import { computed, provide } from 'vue';
import { useJWTVCampaign } from '@/features/jwtv-titles-rental/composables/useJWTVCampaign';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromotedListBuyBox',
  props: {
    promotedOffers: null,
    objectType: null,
    title: null,
    additionalContexts: null
  },
  setup(__props: any) {

const props = __props as {
	promotedOffers: BuyboxRegularOffer[];
	objectType: ObjectType;
	title: TitleDetail;
	additionalContexts: SnowplowContext[];
};



const { tc } = useI18n();
useProvideClickoutPlacement('promoted_buybox');

provide('offerLocation', OfferLocation.PROMOTED_BUYBOX);

const { getPromotedOffersWithJwtv } = useJWTVCampaign();

const allPromotedOffers = computed(() => {
	return getPromotedOffersWithJwtv(props.promotedOffers, props.title);
});

return { __sfc: true,props, tc, getPromotedOffersWithJwtv, allPromotedOffers, ListOffer }
}

})